module.exports = __webpack_public_path__ + "img/client-wash_putin_en.59ea6794.svg";